export default __webpack_public_path__ + "static/media/C2.365c0381.svg";